import { Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ContentHead from "../../components/Admin/Common/ContentHead";
import CustomeHeader from "../../components/Admin/Common/CustomeHeader";
import ViewButton from "../../components/Admin/Common/ViewButton";
import {
  TablePagination,
} from "../../StyledComponents/Common";
import {
  TableTitle,
  TableTop,
} from "../../StyledComponents/CreateKeyAccountManager";
import { MainContainer } from "../../StyledComponents/Dashboard";
import { DeleteOutlined } from '@ant-design/icons';
// import { IconImg } from '../StyledComponents/Header'
import {
  ContentContainer,
} from "../../StyledComponents/RateManagement";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { authuser } from "../../store/Authentication/AuthSlice";
import { ExclamationCircleFilled } from "@ant-design/icons";
// import { shortenString } from '../../functions/Utils'
import { FilterSection, SpinContainer } from "../../StyledComponents/Queries";
import TransportationTable from "../../components/Admin/Common/TransportationTable";
import { get_Ftltransport_rates , delete_Ftltransport_rates } from "../../store/Admin/FTLTransportRateManagement/FTLTransportRateManagement";
import FTLTransportationRateDetailManagement from "../../components/Admin/FTLTransportationRateManagement/FTLTransportationRateDetailManagement";
import AddButton from "../../components/Admin/Common/AddButton";
import moment from "moment";
import SearchBox from "../../components/Admin/Common/SearchBox";
let debounceTimer = null;
function FTLTransportationRateManagement() {
  const dispatch = useDispatch();
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles;
  // const userroles = "air_admin"
  const [tabType, setTabType] = useState(
    userroles === "ocean_admin" ? "ocean" : "air"
  );
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [instance, setInstance] = useState({});
  const [type, setType] = useState("view");
  const [data, setData] = useState([]);
  const [call_list, setCallList] = useState(true);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const { confirm } = Modal;

  useEffect(() => {
    if (call_list) {
      dispatch(get_Ftltransport_rates(''))
        .then((res) => {
          // console.log('login res => ',res);
          if (res?.payload?.status === 200) {
            // console.log(res?.payload?.data,'dat')
            setData(res?.payload?.data?.data);
            setCallList(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // setIsEdit(false)
  }, [call_list, dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleView = (record) => {
    // console.log(record,'record')
    setInstance(record);
    setPageType("view_page");
    setType("view");
  };

  const handleAdd = () => {
      setInstance({});
      setPageType("view_page");
      setType("create");
  };

  const handleBack = () => {
    if (type === "edit") {
      confirm({
        title: "Do you want to exit?",
        icon: <ExclamationCircleFilled />,
        content: "Your changes will not be saved.",
        okButtonProps: {
          style: {
            backgroundColor: "#1890ff",
            borderColor: "#1890ff",
            borderRadius: "4px",
            color: "#fff",
          },
        },
        onOk() {
          setCallList(true);
          setPageType("table");
          setInstance({});
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      // setCallList(true)
      setPageType("table");
      setInstance({});
    }
  };

  const handleDeleteRecord = async (item)=>{
    // console.log(item,'item')
    dispatch(delete_Ftltransport_rates(item?._id)).then((res)=>{
      setData((prev)=>{
        return prev?.filter((data)=>data?._id!==item?._id)
      })

    }).catch(err=>{

    })
  }

  const columns = [
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "VehicleType",
      dataIndex: 'state',
            render: (vehicleType, record, index) => {
                return record?.vehicleType?.name 
              },
    },
    {
      title: "Min Km",
      dataIndex: "minKm",
    },
    {
      title: "Max Km",
      dataIndex: "maxKm",
    },
    {
      title: "Per Km Rate",
      dataIndex: "perKmRate",
    },
    {
      title: "date",
      dataIndex: "createdAt",
      render: (vehicleType, record, index) => {
        return  moment(record?.createdAt).format('DD/MM/YYYY')
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "text-right",
      render: (text, record, index) => {
        // if (index === 0) {
        //   return ''
        // }
       return (
        <Space>
        <ViewButton handleClick={() => handleView(record)} data={record} />
        <div className="icon_delete">
          <DeleteOutlined onClick={() => handleDeleteRecord(record)} style={{ cursor: 'pointer' }} />
        </div>
    </Space>
      );
      },
    },
  ];

  const onSearch = (value) => {
    let queryStringObj = {};
    if (value?.length > 0) {
      queryStringObj["search"] = value;
    }
    let queryString = new URLSearchParams(queryStringObj).toString();
    queryString = queryString ? `?${queryString}` : "";
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      dispatch(get_Ftltransport_rates(queryString))
      .then((res) => {
        // console.log('login res => ',res);
        if (res?.payload?.status === 200) {
          // console.log(res?.payload?.data,'dat')
          setData(res?.payload?.data?.data);
          setCallList(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }, 700);
  };

  
  return (
     <section className="viewRateFTLMain">
    <MainContainer>
      <CustomeHeader title="FTL Transportation Rates" description="Manage FTL rates" />
      {pageType === "table" ? (
        <>
        <div className="tableResponsiveASAP">
          <ContentContainer>
            <TableTop>
              <TableTitle>View Rates</TableTitle>
              <FilterSection className='filter'>
              <SearchBox  onSearch={onSearch} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
              <AddButton title="Add FTL rates" handleClick={handleAdd} />
              </FilterSection>
              
              {/* <DropDownButton1 label="Add FTL rates" items={items} handleDropDownChange={handleAdd} />
              <RateUploadModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                rateType={rateType}
                setCallList={setCallList}
                tabType="transportation"
              /> */}
            </TableTop>

            {loading ? (
              <SpinContainer className="user-quote">
                <Spin />
              </SpinContainer>
            ) : (
              <TransportationTable
                name="rate_management"
                currentPage={currentPage}
                pageSize={pageSize}
                columns={columns}
                data={data}
                rowKey="_id"
                setCallList={setCallList}
                scroll={true}
                showScroll={true}
              />
            )}
          </ContentContainer>
          <div className="paginationCustom">
          <TablePagination
            style={{ marginTop: 16, textAlign: "center" }}
            onChange={handlePageChange}
            onShowSizeChange={handlePageSizeChange}
            defaultCurrent={currentPage}
            defaultPageSize={10}
            total={data?.length ? data?.length : 10}
            showSizeChanger={false}
            showQuickJumper={false}
          />
          </div>
          </div>
        </>
      ) : pageType === "view_page" ? (
        <ContentContainer>
          <ContentHead
            title="Details"
            handleClick={() => handleBack()}
            border={false}
          />
          <FTLTransportationRateDetailManagement
            type={type}
            instance={instance}
            setPageType={setPageType}
            setType={setType}
            setCallList={setCallList}
            tabType={tabType}
            setTabType={setTabType}
          />
        </ContentContainer>
      ) : null}
    </MainContainer>
    </section>
  );
}

export default FTLTransportationRateManagement;
